import { render, staticRenderFns } from "./SafePhone.vue?vue&type=template&id=772ed0bb&scoped=true&"
import script from "./SafePhone.vue?vue&type=script&lang=js&"
export * from "./SafePhone.vue?vue&type=script&lang=js&"
import style0 from "./SafePhone.vue?vue&type=style&index=0&id=772ed0bb&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "772ed0bb",
  null
  
)

export default component.exports